import { Box, Typography, Stack } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';
import useSWR from 'swr';
import { useState } from 'react';
import {
  gridDateTimeFormatter,
  mapGridIndexes,
  queryParams,
} from '@shared/commonFunctions';
import { dataGridCol, gridCurrencyCell } from '@shared/components/grid/common';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { SERVICES } from '@shared/constants/apiConfig';

import { DealSheetHeader } from '@styles/DealSheet/DealSheetStyles';
import { viewDealSummary } from '../queries';
import { DealSheetSummaryModal } from './DealSheetSummaryModal';


export const DealSheets = () => {
  const params = queryParams();
  const { data } = useSWR(params?.dealId && `/${SERVICES.ACCOUNTING}/accounting/dealsheet/${params?.dealId}`);
  let dealSheets = data;

  if (dealSheets && dealSheets.length) {
    dealSheets = dealSheets?.slice().sort((i: any, j: any) => {
      const d: number = (new Date(j.createdDate) as unknown as number) - (new Date(i.createdDate) as unknown as number);
      return d;
    });
    dealSheets.length = 1;
  }

  const columns: GridColDef[] = [
    dataGridCol('dealSheetNumericId', {
      headerName: 'ID'
    }),
    dataGridCol('createdDate', {
      headerName: 'Created On',
      type: 'dateTime',
      valueFormatter: gridDateTimeFormatter,
    }),
    dataGridCol('cudlAmountFinanced', { headerName: 'Amount', ...gridCurrencyCell }),
    dataGridCol('commission', { ...gridCurrencyCell }),
  ].map((i) => ({ ...i, flex: 1 }));

  const [dealSheetSummaryModalOpenStatus, handleDealSheetSummaryModalOpenStatus] = useState<boolean>(false);
  const [fileContents, setFileContents] = useState('');
  const viewDealSheetSummary = async () => {
    const file =  await viewDealSummary(params?.dealId);
      setFileContents(file);
      handleDealSheetSummaryModalOpenStatus(true);
  };

  return (
    <>
      <DealSheetHeader>
          <Stack direction={'row'} sx={{ justifyContent: 'space-between' }}>
            <Typography variant="h3" mt={2} >
              Deal Sheets
            </Typography>
            <Typography variant="subtitle1" mt={2}  onClick={() => viewDealSheetSummary()} >
              View Deal Summary
            </Typography>
            </Stack>
      </DealSheetHeader>
      <Box>
        <PhoenixGrid
          autoHeight
          hideFooter
          canNotCopy
          showClearAllFilter
          disableSelectionOnClick
          columns={columns}
          rows={mapGridIndexes(dealSheets)}
        />
      </Box>

        <DealSheetSummaryModal
          open= {dealSheetSummaryModalOpenStatus}
          handleClose={() => handleDealSheetSummaryModalOpenStatus(false)}
          fileContents={fileContents}
        />
    </>
  );
};
